/**
 * Plural noun forms, keyed by CLDR plural category. `other` is required because it is the form
 * `Intl.PluralRules` falls back to for every category a locale does not distinguish.
 */
export type PluralForms = Partial<Record<Intl.LDMLPluralRule, string>> & { other: string }

const pluralRules = new Intl.PluralRules('en-US')

/**
 * The noun form for a count. `Intl.PluralRules` picks the category, so `0`, decimals, and other
 * locales come out right where `count === 1 ? a : b` gets them wrong.
 */
export const pluralize = (count: number, forms: PluralForms): string =>
  forms[pluralRules.select(count)] ?? forms.other

export const withCount = (count: number, forms: PluralForms): string =>
  `${count} ${pluralize(count, forms)}`

const HTML_ENTITIES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  '\'': '&#39;',
}

/** Text safe to interpolate into markup that is rendered with `v-html`; any value is stringified first. */
export const escapeHtml = (value: unknown): string =>
  String(value ?? '').replace(/[&<>"']/g, char => HTML_ENTITIES[char] ?? char)
